import React from 'react';
import { Chip } from '@material-ui/core';
import { IReturn as Applicant } from '../../../api/resources/Applicant';

// 'TR' marks an applicant as a member of the Transfer bucket (see
// api/applicants/models.py Applicant.TRANSFER).
const TRANSFER_INTENT = 'TR';

interface IProps {
    applicant: Applicant;
}

// Small visual indicator shown on the applicant detail view when the applicant
// is currently in the Transfer bucket. Renders nothing otherwise.
const TransferBadge: React.FC<IProps> = ({ applicant }) => {
    if (applicant.applicant_intent !== TRANSFER_INTENT) {
        return null;
    }
    return <Chip color="secondary" size="small" label="Transfer" />;
};

export default TransferBadge;
